import React from 'react';
import PropTypes from 'prop-types';
import flags from '../../static-data/flags';
import config from '../../config';

export default class SelectCountryOptions extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        children: PropTypes.node,
        className: PropTypes.string.isRequired,
        onFocus: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
        isFocused: PropTypes.bool.isRequired,
        // eslint-disable-next-line
        option: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event);
    }

    handleMouseMove(event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    showFlags(name) {
        return (name === undefined ? null 
            : <span
                className="table__column__flag"
                style={{ backgroundImage: `url(${config.imagesUrl}/images/flags/${flags[this.props.children]})` }}
            />
        );
    } 

    render() {
        return (
            // eslint-disable-next-line
            <div
                className={this.props.className}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                title={this.props.option.title}
            >
                {this.showFlags(this.props.children)}
                {this.props.children || ''}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Medals/SelectOption.jsx